interface EnvConfig {
  env: string
  apiBaseUrl: string
  appTitle: string
  isDevelopment: boolean
  isTest: boolean
  isProduction: boolean
}

const getEnvConfig = (): EnvConfig => {
  const env = import.meta.env.VITE_ENV || 'development'
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || ''
  const appTitle = import.meta.env.VITE_APP_TITLE || '一点PPT'

  return {
    env,
    apiBaseUrl,
    appTitle,
    isDevelopment: env === 'development',
    isTest: env === 'test',
    isProduction: env === 'production',
  }
}

export const envConfig = getEnvConfig()